import {Form} from "antd";
import {useParams} from "react-router-dom";
import {API} from 'aws-amplify'
import React, {useEffect} from 'react'
import {SYSTEMIDENTITYID} from "../../../../../../../assets/scripts/constants";
import useS3 from "../../../../../../providers/useS3";
import {useAdminMortgageTestForMax} from "./useAdminMortgageTestForMax";
import useAdminMortgageTestForPass from "./useAdminMortgageTestForPass";


export const LenderTestFiguresContext = React.createContext({})

function LenderTestFiguresProvider({children}) {
    const params = useParams()
    const mortgageID = params.mortgageId
    const {tests: maxTests, activeTest: activeMaxTest, loadTest: loadMaxTest, refreshTestHistory: refreshMaxTestHistory, busy: maxBusy, setBusy: setMaxBusy} = useAdminMortgageTestForMax(mortgageID)
    const {tests: passTests, activeTest: activePassTest, loadTest, refreshTestHistory: refreshPassTestHistory, busy : passBusy, setBusy: setPassBusy} = useAdminMortgageTestForPass(mortgageID)
    const s3 = useS3()

    const [form] = Form.useForm()
    /*
    "fixedRateYears": 3,
        "mortgageType": "PURCHASE",
        "twoApplicants": true,
        "dependents": [
            {
                "age": 2
            }
        ],
        "termRequired": 22,
        "loanRequired": 198454,
        "propertyValue": 444443,
        "applicant1": {
            "works": true,
            "maritalStatus": "SINGLE",
            "age": 26,
            "jobs": [
                {
                    "sector": "PRIVATE",
                    "basic": {
                        "yearMostRecent": 35000,
                        "guaranteed": true
                    },
                    "overtime": {
                        "yearMostRecent": 2300,
                        "yearBefore": 4000,
                        "yearBeforeThat": 3000,
                        "guaranteed": false
                    },
                    "hasVariable": 9300,
                    "hasNonGaranteedAdditionalIncome": true
                }
            ],
            "pra": {
                "rent": 300,
                "savings": 834
            },
            "monthlyOutgoings": {
                "loans": 230,
                "maintenance": 100
            }
        },
        "applicant2": {
            "works": true,
            "maritalStatus": "SINGLE",
            "age": 26,
            "jobs": [
                {
                    "sector": "PRIVATE",
                    "basic": {
                        "yearMostRecent": 23000,
                        "guaranteed": true
                    },
                    "hasNonGaranteedAdditionalIncome": false
                }
            ],
            "pra": {
                "rent": 400,
                "savings": 333
            },
            "creditFacilityLimits": 3000
        },
        "deposit": 53333,
        "selfBuild": false,
        "oneBedProperty": false,
        "propertyIdentified": true,
        "berScore": "A3",
        "propertyType": "SEMIDETACHED",
        "applicationType": "MOVINGHOME",
        "fundsAvailable": 53333,
        "savings": 53333,
        "htb": 30000,
        "funds": {
            "savings": 53333
        },
        "numberOfDependentChildren": 1,
        "numberInHousehold": 3
     */

    const openXls = async (url) => {
        if (url.endsWith('.html')) {
            // Nua test not a xls
            url = await s3.getS3Url({
                path  : url,
                config: {
                    contentType: 'text/html',
                    level      : "private",
                    identityId : SYSTEMIDENTITYID
                }
            })
        }
        s3.openDocument(url, 'xlsSheet')

    }

    const expandFigures = (figures) => {
        figures.applicant1.creditFacilityLimits = (figures.applicant1?.credit?.creditCardLimits || 0) + (figures.applicant1?.credit?.overdraftLimits || 0)
        figures.applicant1.highestCreditUtilisation = (figures.applicant1?.credit?.maxCardUtilisation || 0) + (figures.applicant1?.credit?.maxOverdraftUtilisation || 0)
        if (figures.twoApplicants){
            figures.applicant2.creditFacilityLimits = (figures.applicant2?.credit?.creditCardLimits || 0) + (figures.applicant2?.credit?.overdraftLimits || 0)
            figures.applicant2.highestCreditUtilisation = (figures.applicant2?.credit?.maxCardUtilisation || 0) + (figures.applicant2?.credit?.maxOverdraftUtilisation || 0)
        }
        if (figures.twoApplicants){
            const applicant1 = figures.applicant1
            const applicant2 = figures.applicant2

            if (!applicant1.works && applicant2.works) {

                figures.applicant1 = applicant2
                figures.applicant2 = applicant1
            } else if (applicant1.works && applicant2.works) {
                const applicant1Income = applicant1.jobs?.reduce((sum, job) => {
                    return sum + (job.basic?.yearMostRecent || 0)
                }, 0)
                const applicant2Income = applicant2.jobs?.reduce((sum, job) => {
                    return sum + (job?.basic?.yearMostRecent || 0)
                }, 0)
                if (applicant2Income > applicant1Income) {
                    figures.applicant1 = applicant2
                    figures.applicant2 = applicant1
                }
            }
        }

    }

    const tests = {
        max:{
            test: async () => {
                const {propertyValue, loanRequired, lenders, ...figures} = await form.validateFields()
                if (!lenders?.length){
                    return
                }


                expandFigures(figures)
                console.log('***** Logging Figures *****')
                console.log(figures)
                setMaxBusy(true)
                const input = {
                    mortgageID,
                    lenders,
                    figures,
                    verifiedFiguresUsed: false
                }

                await API.post('sussdAdminAPI', '/operations/lender-tests/test-for-max', {
                    body: input
                })


            },
            tests: maxTests,
            loadTest: loadMaxTest,
            active: activeMaxTest,
            refresh: refreshMaxTestHistory,
            busy: maxBusy
        },
        pass:{
            test: async ()=>{
                const {lenders, ...figures} = await form.validateFields()
                if (!lenders?.length){
                    return
                }
                console.log('***** Logging Figures *****')
                console.log(figures)
                expandFigures(figures)
                setPassBusy(true)
                const input = {
                    mortgageID,
                    lenders,
                    figures,
                    verifiedFiguresUsed: false
                }

                await API.post('sussdUserAPI', '/tests/lenders', {
                    body: input
                })
            },
            tests: passTests,
            loadTest: loadTest,
            active: activePassTest,
            refresh: refreshPassTestHistory,
            busy: passBusy
        }
    }
    /*
    default 67

    const applicantAllowedTerms = applicants.map(app=>{
        if (this.term?.pension && app.hasPension){
          return this.term.pension - app.age
        }
        if ( this.term?.selfEmployed && app.works && app.jobs.some(job=>job.sector === 'SELF') ){
          return this.term.selfEmployed - app.age
        }
        return this.term.default - app.age
    })
    const maxTerm = Math.min(35, ...applicantAllowedTerms)
     */
    useEffect(() => {
        form.resetFields()
    }, [mortgageID]);

    return (
        <LenderTestFiguresContext.Provider key={mortgageID}
            value={{
                mortgageID,
                form,
                tests,
                openXls,
            }}>
            {children}
        </LenderTestFiguresContext.Provider>
    );
}

export default LenderTestFiguresProvider;